export default __webpack_public_path__ + "static/media/hamburg.1438267e.png";